import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import moment from 'moment';
import { Subject, debounceTime, of } from 'rxjs';
import { CONFIG_BASE_DATE_RANGEPICKER } from '../../../../../../../core/constants/constants';
import { ChargesWithdrawalsRequestService } from '../../../../../../../core/services/charges-withdrawals-request.service';
import { FilterCommunicationService } from '../../../../../../../core/services/filter-communication.service';
import { FinancialService } from '../../../../../../../core/services/financial.service';
import { StateService } from '../../../../../../../core/services/state.service';
import { UserService } from '../../../../../../../core/services/user.service';
import { movementType } from '../../../../../../../shared/data/suscriptions-payments/constants';
import { ChargesWithdrawalsService } from '../../../../../../../core/services/charges-withdrawals.service';
import { ActivatedRoute, Router } from '@angular/router';
import { selectAuth } from '../../../../../../../core/state/auth/auth.selector';
import { Store } from '@ngrx/store';
import { CountryService } from '../../../../../../../core/services/country.service';
import { ROLES } from '../../../../../../../shared/data/config/constants';
import { UserMainService } from '../../../../../../user/services/user-main.service';
import { agentTypes } from '../../../../../../../shared/data/loads-withdrawal/constants';

@Component({
  selector: 'app-list-lw-filters',
  templateUrl: './list-lw-filters.component.html',
  styleUrl: './list-lw-filters.component.scss',
})
export class ListLwFiltersComponent implements OnInit {
  public listLwFormFilter!: FormGroup;
  public optionsHolder$: any;
  public optionsAgents$: any;
  public optionsCreatedBy$: any;
  public optionsBanks$: any;
  public optionsState$: any;
  public optionsCountries$: any;
  public optionsCategory$: any;
  public optionsMovementType$: any;
  public createUser$: any;
  public id_country!: any;
  public currentPageAgents = 1;
  public currentPageCreatedBy = 1;
  public currentPageHolders = 1;
  public allAgentsData: any[] = [];
  public allHoldersData: any[] = [];
  public allCreatedBy: any[] = [];
  public pageSize = 10;
  public criteria: any;
  private filterSubject: Subject<string> = new Subject<string>();
  public showFilter: boolean = false;
  public selectedBankId: any;
  public transformedDataBank: any;
  public responseCreateUser: any;
  public id_agente: any;
  isMobile: boolean = false;
  token!: string;
  public hasMoreCreatedBy: boolean = true;
  public agentTypes = agentTypes;

  //LOGGEDSUSER
  public profile$ = this.store.select(selectAuth);
  public profile: any;
  public ROLES = ROLES;
  //DATE
  //DATE
  public bsConfig = CONFIG_BASE_DATE_RANGEPICKER.bsConfig;
  public initialRange: Date[] = CONFIG_BASE_DATE_RANGEPICKER.initialRange;

  constructor(
    private fb: FormBuilder,
    private _userService: UserService,
    private _filterCommunicationService: FilterCommunicationService,
    private stateSevice: StateService,
    private lwService: ChargesWithdrawalsService,
    private router: Router,
    private activedRouter: ActivatedRoute,
    private store: Store,
    private _countryService: CountryService,
    private _userMainService: UserMainService
  ) {
    this.initForm();
    this.filterSubject.pipe(debounceTime(400)).subscribe((term: string) => {
      this.allAgentsData = [];
      this.allCreatedBy = [];
      this.loadAgents(term);
      this.getCreatedByUsers(term, true);
    });
  }

  async ngOnInit(): Promise<void> {
    const fullUrl = this.router.url;
    this.isMobile = fullUrl.includes('/mobile');
    if (this.isMobile) {
      await new Promise<void>((resolve, reject) => {
        this.activedRouter.params.subscribe((params) => {
          this.token = params['token'];
          this._userService.getUserByTokenApp(this.token).subscribe({
            next: (res) => {
              if (res.data.idusuario) {
                this.profile = res.data;
                this.id_agente = this.profile.idusuario;
                this.listLwFormFilter
                  .get('id_agente')
                  ?.setValue(this.profile.idusuario);
                resolve();
              } else {
                reject(new Error('No user id found'));
              }
            },
            error: (err) => {
              reject(err);
            },
          });
        });
      });
    } else {
      await new Promise<void>((resolve, reject) => {
        this.profile$.subscribe({
          next: (res) => {
            if (res.idusuario !== -1) {
              this.profile = res;
              if (this.profile.id_rol === 4) {
                this.listLwFormFilter
                  .get('id_agente')
                  ?.setValue(this.profile?.idusuario);
              } else {
                this.loadAgents();
              }
              resolve();
            }
          },
          error: (err) => {
            reject(err);
          },
        });
      });
    }
    this.getCreatedByUsers();
    this.getStatesLw();
    this.getCategoriesLw();
    this.getCountries();
    this.sendFilter();
  }

  //?LOAD DATA
  loadAgents(searchTerm?: string) {
    this._userMainService
      .getAllReferredAndAgents(
        this.currentPageAgents,
        this.pageSize,
        searchTerm,
        this.id_country
      )
      .subscribe((response) => {
        const transformedData = response.data.map(
          (item: { usuario: any; idusuario: any }) => {
            return { label: item.usuario, value: item.idusuario };
          }
        );
        this.optionsAgents$ = of(transformedData);
        this.allAgentsData = [...this.allAgentsData, ...transformedData];
      });
  }
  getCountries() {
    this._countryService.getAllCountries().subscribe((res) => {
      const transformedData = res.data.map(
        (item: { pais: number; id_pais: string }) => {
          return {
            label: item.pais,
            value: item.id_pais,
          };
        }
      );
      this.optionsCountries$ = of(transformedData);
    });
  }

  getCreatedByUsers(searchTerm?: string, isNewSearch: boolean = false) {
    if (isNewSearch) {
      this.currentPageCreatedBy = 1;
      this.allCreatedBy = [];
    }

    this.lwService
      .getUsersForSelect(
        this.currentPageCreatedBy,
        this.pageSize,
        searchTerm?.trim(),
        undefined
      )
      .subscribe((response) => {
        const transformedData = response.data.result.map(
          (item: { username: string; userId: number }) => {
            return { label: item.username, value: item.username };
          }
        );

        if (this.currentPageCreatedBy === 1) {
          this.allCreatedBy = transformedData;
        } else {
          this.allCreatedBy = [...this.allCreatedBy, ...transformedData];
        }

        this.optionsCreatedBy$ = of(this.allCreatedBy);

        this.hasMoreCreatedBy = this.currentPageCreatedBy < response.data.totalPages;
      });
  }
  getCategoriesLw() {
    this.lwService.getCategories().subscribe((response) => {
      const transformedData = response.data.map(
        (item: { categoria: any; idcare_categoria: any }) => {
          return { label: item.categoria, value: item.idcare_categoria };
        }
      );
      this.optionsCategory$ = of(transformedData);
    });
  }
  getStatesLw() {
    this.stateSevice.geatAllDataLw().subscribe((response) => {
      const transformedData = response.data.map(
        (item: { estado: any; n_estado: any }) => {
          return { label: item.estado, value: item.n_estado };
        }
      );
      this.optionsState$ = of(transformedData);
    });
  }

  //*NG-SELECT
  onScrollToEnd() {
    this.currentPageAgents++;
    this.loadAgents(this.criteria);

    if (this.hasMoreCreatedBy) {
      this.currentPageCreatedBy++;
      this.getCreatedByUsers(this.criteria, false);
    }
  }
  onSearch(term: string) {
    this.criteria = term;
    this.currentPageAgents = 1;
    this.currentPageCreatedBy = 1;

    this.allAgentsData = [];
    this.allCreatedBy = [];

    this.filterSubject.next(term);
  }

  //*TOGGLE
  toggleChart() {
    this.showFilter = !this.showFilter;
  }
  getShowFilterStyle(): { [key: string]: string } {
    return this.showFilter
      ? { overflow: 'visible', maxHeight: '600px' }
      : { overflow: 'hidden', maxHeight: '0' };
  }

  //*FORM
  initForm() {
    this.listLwFormFilter = this.fb.group({
      id_agente: [null],
      createdBy: [null],
      state: [null],
      dateRange: [this.initialRange],
      category: [null],
      amount: [null],
      country: [null],
      comentary: [null],
      agentType: [null],
    });
  }

  sendFilter(): void {
    if (!this.listLwFormFilter.valid) return;

    const filterValues = this.listLwFormFilter?.value;
    const dateRange = filterValues?.dateRange;

    const formattedFilter = {
      date_start:
        dateRange && dateRange[0]
          ? moment(dateRange[0]).format('YYYY-MM-DD 00:00:00')
          : null,
      date_end:
        dateRange && dateRange[1]
          ? moment(dateRange[1]).format('YYYY-MM-DD 23:59:59')
          : null,
    };

    let filters = {
      id_agente:
        this.profile?.id_rol === ROLES.AGENT
          ? this.profile.idusuario
          : filterValues.id_agente,
      createdBy: filterValues.createdBy,
      agentType: filterValues.agentType,
      state: filterValues.state,
      datestart: formattedFilter.date_start,
      dateend: formattedFilter.date_end,
      category: filterValues.category,
      amount: filterValues.amount,
      country: filterValues.country,
      comentary: filterValues.comentary,
    };
    this._filterCommunicationService.changeFilter(filters);
  }

  resetForm(): void {
    let clearFilter: any;
    this.listLwFormFilter.reset({
      id_agente:
        this.isMobile || this.profile?.id_rol === ROLES.AGENT
          ? this.profile?.idusuario
          : null,
      createdBy: null,
      agentType: null,
      state: null,
      dateRange: this.initialRange,
      category: null,
      amount: null,
      country: null,
      comentary: null,
    });

    const formattedFilter = {
      date_start: this.initialRange[0]
        ? moment(this.initialRange[0]).format('YYYY-MM-DD HH:mm:ss')
        : null,
      date_end: this.initialRange[1]
        ? moment(this.initialRange[1]).format('YYYY-MM-DD HH:mm:ss')
        : null,
    };

    clearFilter = {
      id_agente:
        this.isMobile || this.profile?.id_rol === ROLES.AGENT
          ? this.profile?.idusuario
          : null,
      createdBy: null,
      agentType: null,
      state: null,
      datestart: formattedFilter.date_start,
      dateend: formattedFilter.date_end,
      category: null,
      amount: null,
      country: null,
      comentary: null,
    };

    this._filterCommunicationService.changeFilter(clearFilter);
  }

  //*UTILS
  capitalizeName(name: string): string {
    return name
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
